import request from '@/utils/request.js'

/**
 * 首页相关接口
 */
// 首页主数据
export const indexHome = (obj) => {
  return request({
    url: 'index/index',
    method: 'get',
  })
}

/**
 * 新闻相关接口
 */
// 新闻列表
export const NewsList = (params) => {
  return request({
    url: 'index/clist',
    method: 'get',
    params
  })
}

// 新闻详情
export const NewsDetail = (obj) => {
  return request({
    url: 'index/detail',
    method: 'get',
    params: obj
  })
}


